/* eslint-disable react/jsx-one-expression-per-line */
import React from 'react';
import { Text, View } from '@react-pdf/renderer';
import { styles } from '../styles';

export const CustomerBox = ({ customer }) => (
  <View style={styles.box}>
    <Text style={styles.rowHeader}>{customer.title}</Text>
    <Text style={{}}>{customer.office}</Text>
    <Text style={{}}>{customer.street}</Text>
    <Text style={{}}>
      {customer.postalcode} {customer.city}
    </Text>
    <Text style={{}}>{customer.country}</Text>
  </View>
);
